import React, { useEffect, useState } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import ThreeCanvas from '../../components/Three/ThreeCanvas';
import ScrollButton from '../../components/common/ScrollButton';
import { PopupButton } from 'react-calendly';
import './Home.css';
import OfferBar from '../../components/OfferBar/OfferBar';
import ScrollDownArrow from '../../components/ScrollDownArrow/ScrollDownArrow';
import Sale from '../../components/HomeSections/Sale/Sale';
import LoadingScreen from '../../components/LoadingScreen/LoadingScreen';

export default function Home() {
  const [currentSection, setCurrentSection] = useState(0);
  const [assetsLoaded, setAssetsLoaded] = useState(false);


  /* IntersectionObserver – track which section is in view */
  useEffect(() => {
    const sections = document.querySelectorAll('.snap-section');
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setCurrentSection([...sections].indexOf(entry.target));
          }
        });
      },
      { threshold: 0.3 },
    );
    sections.forEach(s => observer.observe(s));
    return () => sections.forEach(s => observer.unobserve(s));
  }, []);

  return (
    <>
      {!assetsLoaded && <LoadingScreen onLoaded={() => setAssetsLoaded(true)} />}

      {/* <Navbar /> */}
      <OfferBar />
      <main className="snap-container">
        {/* ───── Hero ───── */}
        <section id="hero" className="snap-section hero">
          <div className="hero__content">
            <div className="hero__logo-wrapper">
              <img
                src="/CustomCaratsLogoLarge.png"
                alt="CustomCarats"
                className="hero__logo"
              />
            </div>
            <h1>Bespoke Diamond Jewellery</h1>
            <p className='phone-hide'>
              Highest quality certified diamond jewellery tailored just for you.
            </p>
            <p>Unbeatable quality at a guaranteed best price.</p>
            <div className="hero__actions phone-hide">
              <ScrollButton targetId="consultation" className="btn btn--primary">
                Book Consultation
              </ScrollButton>
              <ScrollButton targetId="sale" className="btn btn--sale">
                Opening SALE
              </ScrollButton>
            </div>
            <div className='btn--big-sale-container phone-only'>
                <ScrollButton targetId="sale" className='btn btn--big-sale'>
                    <div className='btn--big-sale-content'>
                        <span><h3>LIMITED TIME DEAL</h3>
                            Bespoke ring<br/>
                            Any design<br/>
                            Up to 2.0ct VVS diamonds<br/><br/>
                            <span style={{fontSize:"0.8rem"}}> + Complementary moissanite travel ring<br/>
                            + Only 20% deposit required</span><br/>
                            <div style={{display:'flex', flexDirection:'row', justifyContent:'center'}}>
                            <span style={{textDecoration: 'line-through', textDecorationThickness: '0.15rem'}}>£3200</span> <span>  -> £1499</span>
                            </div>
                        </span>
                    <ScrollDownArrow nextSectionClass="sale"/>
                    </div>
                </ScrollButton>
            </div>
          </div>
          {/* <ScrollDownArrow nextSectionClass={"craftsmanship"} /> */}
        </section>

        {/* ───── Craftsmanship ───── */}
        <section className="snap-section craftsmanship">
          <div className="section-narrow craftsmanship__content">
            <h2>Our Craftsmanship</h2>
            <p>
              Each ring is designed meticulously, combining gold, silver, and
              brilliant diamonds for a perfect finish. We manufacture our
              lab-grown diamonds in-house, allowing us to ensure they are of the
              highest quality. Depending on the customer's needs, we are able
              to provide 18ct, 14ct and 9ct white/yellow gold as well as
              silver. All our products come hallmarked, with certifications for
              the diamonds.
            </p>
            <p>
              All primary diamonds certified VVS with G+ clarity. Additional
              adjustments negotiable depending on your needs.
            </p>
          {/* <ScrollDownArrow nextSectionClass={"why-process"} /> */}
          </div>
        </section>

        {/* ───── Why / Process ───── */}
        <section className="snap-section why-process">
          <div className="why-process__columns">
            <div className="why">
              <h2>Why Choose CustomCarats?</h2>
              <p>
                We leverage the fact that we can produce diamonds in-house along
                with our partnership with various jewellers to provide a unique
                piece to every customer. We design and manufacture each piece
                individually as per the customer's requirements. Unlike other
                online jewellers, we don't take out the human touch from our
                customer's experience, ensuring each experience is tailored
                perfectly to their needs. All of this is provided at a
                guaranteed lowest price on the UK market.
              </p>
              <p>
                If you want premium quality, bespoke rings at a price better
                than any competitor on the market, book a meeting with us.
              </p>
            </div>
            <div className="process">
              <h2>Our Process</h2>
              <ol className="process__steps">
                <li>Initial consultation <p>Discuss what you're looking for and how we can help</p></li>
                <li>Design Review <p>Review shortlisted designs and select desired design</p></li>
                <li>CAD design review &amp; material/stone selection <p>Review a custom CAD model and finalize the specifications of the diamonds wanted + material for the ring. Only 20% deposit required here to place an order.</p></li>
                <li>Crafting &amp; quality assurance <p>We take 3-4 weeks to get the ring of your dreams crafted.</p></li>
                <li>Final presentation or secure delivery <p>You get to wear your ring!</p></li>
              </ol>
            </div>
          </div>
        </section>

        {/* for phones only */}
        <section className="snap-section process phone-only">
          <div className="process__columns">
            <div className="process">
              <h2>Our Process</h2>
              <ol className="process__steps">
                <li>Initial consultation <p>Discuss what you're looking for</p></li>
                <li>Design Review <p>Select from shortlisted designs</p></li>
                <li>CAD design review &amp; material/stone selection <p>Review a custom CAD model and finalize the details</p></li>
                <li>Crafting &amp; quality assurance <p>We take 3-4 weeks to get the ring of your dreams crafted</p></li>
                <li>Final presentation or secure delivery <p>You get to wear your ring!</p></li>
              </ol>
            </div>
          </div>
        </section>

        {/* ───── Opening Sale ───── */}
        <section id="sale" className="snap-section sale">
            <Sale />
        </section>
        {/* <section id="sale" className="snap-section sale">
          <div className="sale__content">
            <h2 className="sale__headline">Opening Sale</h2>
            <h3>
              Any custom diamond ring with up to 2.5ct diamonds for a <br />
              <strong>FIXED PRICE of £1839!</strong>
            </h3>
            <p>
              Purchase a bespoke diamond ring, designed to your taste, with a
              total diamond weight of 2.5ct for just £1839!
            </p>
            <ul className="sale__list">
              <li>
                All diamonds VS-VVS, any desired shape, total weight up to
                2.5ct.
              </li>
              <li>
                Choice of 14ct yellow or white gold. Upgrade to 18ct gold for
                £75.
              </li>
              <li>
                Complementary matching travel ring made of moissanite &amp;
                silver. Gold plating available for £50.
              </li>
              <li>IGI Certificates provided for diamonds.</li>
              <li>One free re-sizing.</li>
              <li>Only 20% deposit required.</li>
              <li>
                Free home delivery or optional £30 personal appointment in
                London for collection with size checking, allowing you to
                inspect your ring before complete payment.
              </li>
              <li>Lead time of only 4 weeks from deposit to door.</li>
              <li>Flexible interest-free payment options available.</li>
            </ul>
            <p>
              For custom requests not covered above, please set an appointment
              below and let us know your specifications.
            </p>
          </div>
        </section> */}

        {/* ───── Consultation ───── */}
        <section
          id="consultation"
          className="snap-section consultation "
        >
          <h2>Book Your Free Consultation</h2>
          <div className='book_container'>
          <p>Discuss your dream design with us - we'll make it a reality.</p>
          <PopupButton
            url="https://calendly.com/customcarats/30min"
            rootElement={document.getElementById('root')}
            className="btn btn--primary btn--narrow"
            text="Book Free Consultation"
            styles={{ /* handled by CSS class */ }}
          />
          </div>
        </section>
      </main>

      {/* Full-screen Three.js canvas */}
      <ThreeCanvas currentSection={currentSection} />
    </>
  );
}